'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NODE_ENV = exports.NODE_ENV = process.env.NODE_ENV || 'development';

var HOST = exports.HOST = process.env.HOST || 'http://localhost';
var PORT = exports.PORT = process.env.PORT || 3000;

var WEBPACK_HOST = exports.WEBPACK_HOST = process.env.WEBPACK_HOST || HOST;
var WEBPACK_PORT = exports.WEBPACK_PORT = process.env.WEBPACK_PORT || PORT + 1;

var WEBPACK_PATH = exports.WEBPACK_PATH = WEBPACK_HOST + ':' + WEBPACK_PORT;

var API_HOST = exports.API_HOST = process.env.API_HOST || 'http://localhost';
var API_PORT = exports.API_PORT = process.env.API_PORT || 8000;

var DISABLE_SERVER_RENDERING = exports.DISABLE_SERVER_RENDERING = process.env.DISABLE_SERVER_RENDERING === 'true' || false;
var SERVER_RELOAD = exports.SERVER_RELOAD = process.env.SERVER_RELOAD || false;

var CLIENT = exports.CLIENT = process.env.CLIENT || false;

var CACHE_EXPIRATION = exports.CACHE_EXPIRATION = process.env.CACHE_EXPIRATION || 60 * 60 * 1000;

// my key
var GOOGLE_MAPS_API_KEY = exports.GOOGLE_MAPS_API_KEY = 'AIzaSyDPLsOY35arzEIgSBtLsxesWuSbh42ZXRs';

var STORE_KEY = exports.STORE_KEY = 'suhu-financialservices';

// server key for node
//export const GOOGLE_MAPS_API_KEY = 'AIzaSyDzu7UvtwxUMGEuY1iMa6QQAKOD';

// browser key
//export const GOOGLE_MAPS_API_KEY = 'AIzaSyAN34gQKrauug2X91A28HvNsuAIcfwYDoY';

var ENABLE_API_CACHING = exports.ENABLE_API_CACHING = false;

var ENABLE_LOCAL_STORAGE = exports.ENABLE_LOCAL_STORAGE = false;

var DEBUG = exports.DEBUG = false;


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 32
// module chunks = 0